import { submitQuestionnaire } from '@/entities/feedback-item';
export async function submitQuestionnaireAction(agentId, answers) {
    await submitQuestionnaire(agentId, answers);
}
